// script.js (sphere index.html) ~sdg
'use strict'
console.time('LoadTime')

import './normalize.css'
import './style.css'
import * as THREE from 'three'
//import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { MeshBasicMaterial } from 'three'

/**
 * Base
 */
// Debug
const gui = new dat.GUI({ width: 200 })
gui.close()
gui.hide()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
const group = new THREE.Group()
scene.add(group)

/**
 * Axes Helper
 */
//const axesHelper = new THREE.AxesHelper(2)
//scene.add(axesHelper)

/*
 * Objects
 */
// Geometries
const sphereGeometry = new THREE.SphereGeometry(0.8)

const smallSphereGeometry = new THREE.SphereGeometry(0.15, 16, 8)


// Textures & Materials
const textureLoader = new THREE.TextureLoader()
const flowerTexture = textureLoader.load('./textures/flower.jpg')
const flowerMaterial = new MeshBasicMaterial({ map: flowerTexture })

const hummerTexture = textureLoader.load('./textures/hummer.jpg')
const hummerMaterial = new MeshBasicMaterial({ map: hummerTexture })

const wireMaterial = new MeshBasicMaterial({ color: 0xffcc33, wireframe: true })

const redMaterial = new MeshBasicMaterial({ color: 0xff0000 })
const purpleMaterial = new MeshBasicMaterial({ color: 0xdd99ff })

// Flower
const flower = new THREE.Mesh(sphereGeometry, flowerMaterial)
flower.position.set(-1, 1.5, -3)
scene.add(flower)

// Wire
const wire = new THREE.Mesh(sphereGeometry, wireMaterial)
wire.rotation.x = Math.PI * 0.25
wire.rotation.z = - Math.PI * 0.15
scene.add(wire)

// Small Spheres
const red = new THREE.Mesh(smallSphereGeometry, redMaterial)
red.position.x = 0.5

const centerFlower = new THREE.Mesh(smallSphereGeometry, flowerMaterial)
centerFlower.position.z = - 0.5

const purple = new THREE.Mesh(smallSphereGeometry, purpleMaterial)
purple.position.x = - 0.5

const centerHummer = new THREE.Mesh(smallSphereGeometry, hummerMaterial)
centerHummer.position.z = 0.5

const smallHummer = new THREE.Mesh(smallSphereGeometry, hummerMaterial)

scene.add(smallHummer)
group.rotation.x = Math.PI * 0.2
group.add(red, centerFlower, purple, centerHummer)

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}
// Resize
window.addEventListener('resize', () =>
{
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight

  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()

  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 3.5
/*camera.position.x = 0.5*/
scene.add(camera)

// Controls
//const controls = new OrbitControls(camera, canvas)
//controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const animate = () =>
{
  const elapsedTime = clock.getElapsedTime()

  // Update controls
  //controls.update()

  // Update objects
  flower.rotation.x = elapsedTime
  flower.rotation.y = elapsedTime

  wire.rotation.y = elapsedTime * 0.25

  group.rotation.y = - elapsedTime * 2

  smallHummer.rotation.y = elapsedTime
  smallHummer.position.x =  Math.sin(elapsedTime)
  smallHummer.position.y =  Math.cos(elapsedTime)

  // Render
  renderer.render(scene, camera)

  // Call animate again on next frame
  window.requestAnimationFrame(animate)
}

animate()
console.timeEnd('LoadTime')
// EOF script.js (sphere index.html) ~sdg